import { render, staticRenderFns } from "./ListServiceCenterPage.vue?vue&type=template&id=5b518e44"
import script from "./ListServiceCenterPage.vue?vue&type=script&lang=js"
export * from "./ListServiceCenterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports